import { logout, login } from '@/api/login-util';
import { Mutations } from '@/store/mutations';
import { SysUser } from '@/types/api-beans';
import { getToken, removeToken, setToken } from '@/utils/auth';
import { decrypt, encrypt } from "@/utils/jsencrypt";

import { api } from '../../plugins/api';

const user = {
  state: {
    sysUser: null,
    token: getToken(),
    name: '',
    username: '',
    avatar: '',
    roles: [],
    permissions: [],
    ready: false,
    videoStreamArr: [] // 5g视频流
  },

  getters: {
    accidentRoleName: state =>
      state.sysUser?.roles?.find(it =>
        ['Agent', 'TrafficPolice', 'Insurance'].includes(it.roleKey)
      )?.roleName,
    isAdmin: state => state.roles.includes('admin'),
    userName: state => state.sysUser ? state.sysUser.userName : 'system',
  },

  mutations: {
    [Mutations.SET_TOKEN]: (state, token) => {
      state.token = token;
    },
    [Mutations.SET_USER]: (state, user: SysUser) => {
      state.sysUser = user;
      state.name = user.nickName;
      state.username = user.userName;
      state.avatar =
        user.avatar === ''
          ? require('@/assets/images/avatar.png')
          : process.env.VUE_APP_BASE_API! + user.avatar;
      localStorage.setItem('userInfo', '@'+state.roles[0]+'-'+state.name+'-'+user.userId+'@');
    },
    [Mutations.CHANGE_READY_STATE]: state => {
      state.ready = true;
    },
    [Mutations.CHANGE_LEAVE_STATE]: state => {
      state.ready = false;
    },
    [Mutations.SET_ROLES]: (state, roles) => {
      state.roles = roles;
    },
    [Mutations.SET_PERMISSIONS]: (state, permissions) => {
      state.permissions = permissions;
    },
    SET_VIDEOSTREAMARR:(state, data) => {
      state.videoStreamArr = [...data];
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = encrypt(userInfo.password);
      const code = userInfo.code;
      const uuid = userInfo.uuid;
      const loginType:any = localStorage.getItem('loginType');
      console.log(loginType);

      return new Promise((resolve, reject) => {
        login({
          username,
          password,
          code,
          uuid
        },loginType)
          .then(token => {
            setToken(token.data);
            commit('SET_TOKEN', token.data);
            resolve(token.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        api.getInfo
          .r()
          .then(data => {
            const user = data.user!;
            if (data.roles && data.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit(Mutations.SET_ROLES, data.roles);
              commit(Mutations.SET_PERMISSIONS, data.permissions);
            } else {
              commit(Mutations.SET_ROLES, ['ROLE_DEFAULT']);
            }
            commit(Mutations.SET_USER, user);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            commit('SET_PERMISSIONS', []);
            removeToken();
            resolve(undefined);
            let loginType:any = localStorage.getItem('loginType');
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('loginType', loginType);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve(undefined);
      });
    }
  }
};

export default user;
